import { stringify } from 'qs';
import { useQuery } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import { FileExtensions } from 'bricks/constants';
import { IDealDirectory } from '../types';
import { DealDocumentType } from '../constants';

export interface IFilters {
    types?: DealDocumentType[];
    formats?: FileExtensions[];
}
interface IDealDirectoryTreeQueryParams {
    dealId: number;
    onlyDir?: boolean; // Optional, defaults to false if not provided
    filters?: IFilters;
    searchValue?: string;
    options?: { enabled?: boolean };
}

const getDealDirectoryTree = async ({
    dealId, onlyDir = false, filters, searchValue,
}: IDealDirectoryTreeQueryParams): Promise<IDealDirectory> => {
    const response = await axiosInstance.get(`${API_ENDPOINTS.DEAL_DIRECTORY.TREE(dealId)}`, {
        params: { only_dir: onlyDir, ...(filters || {}), search_value: searchValue },
        paramsSerializer: params => stringify(params, { arrayFormat: 'repeat' }),
    });
    return response.data;
};

export const useGetDealDirectoryTree = ({
    dealId, onlyDir = false, filters, searchValue, options = {},
}: IDealDirectoryTreeQueryParams) => useQuery({
    queryKey: [QUERY_KEYS.DEAL_DIRECTORY_TREE, dealId, onlyDir, filters, searchValue],
    queryFn: () => getDealDirectoryTree({
        dealId, onlyDir, filters, searchValue,
    }),
    refetchOnMount: true,
    ...options,
});

export default useGetDealDirectoryTree;
